/**
 * プロトコルタイプ
 */
export var ProtocolTypes;

(function (ProtocolTypes) {
  /**
   * UDP接続
   */
  ProtocolTypes[ProtocolTypes["Udp"] = 0] = "Udp";
  /**
   * TCP接続
   */

  ProtocolTypes[ProtocolTypes["Tcp"] = 1] = "Tcp";
  /**
   * WSS接続
   */

  ProtocolTypes[ProtocolTypes["Wss"] = 2] = "Wss";
})(ProtocolTypes || (ProtocolTypes = {}));